import { ACTION_ADD_CLIENT_PENDING, ACTION_ADD_CLIENT_SUCCESS, ACTION_ADD_CLIENT_ERROR } from 'actions/client/action.client-add';

const initialState = {
    addClientPending: false,
    addClientError: null
}

export default function addClientReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION_ADD_CLIENT_PENDING:
            return {
                ...state,
                addClientPending: true,
                addClientId: null
            }
        case ACTION_ADD_CLIENT_SUCCESS:
            return {
                ...state,
                addClientPending: false,
                addClientId: action.clientId
            }
        case ACTION_ADD_CLIENT_ERROR:
            return {
                ...state,
                addClientPending: false,
                addClientError: action.addClientError
            }
        default:
            return state;
    }
}

export const addClientPending = state => state.addClientReducer.addClientPending;
export const addClientId = state => state.addClientReducer.addClientId;
export const addClientError = state => state.addClientReducer.addClientError;
